import React from "react";
import "../assets/css/policy.css";
import Navigation from "../components/Navigation";

function TermsAndConditions() {
  return (
    <div className="whole whole--with-navbar legal-page">
      <Navigation minimal />

      <div className="legal-page__content">
        <article className="legal-page__panel">
          <h1 className="legal-page__title">
            <span className="highlight">Terms</span> &amp; Conditions
          </h1>

          <p className="legal-page__intro">
            These terms govern your use of the ReImagine
            <span className="legal-page__brand-italic">2.0</span> platform,
            operated by Traxccel LLC. By accessing or using this website, you
            accept and agree to abide by these terms.
          </p>
          <p className="legal-page__intro">
            These terms and conditions are considered accepted by you when you
            use this website. If you do not agree with the terms and conditions
            stated on this page, then do not continue to use our website.
          </p>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Intellectual Property</h2>
            <p>
              All content, trademarks, and branding on the ReImagine
              <span className="legal-page__brand-italic">2.0</span> platform are
              the intellectual property of Traxccel LLC unless otherwise stated.
              You may not copy, reuse, or reproduce any part of this platform
              without express written consent.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Permitted Use</h2>
            <p>
              You may use the content on this platform for informational and
              internal business assessment purposes only. You may not:
            </p>
            <ol>
              <li>
                Republish, distribute, or commercially exploit any content.
              </li>
              <li>
                Use our content or platform in any way that may cause damage or
                interfere with access for others.
              </li>
            </ol>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">External Links</h2>
            <p>
              This platform may contain links to third-party websites or
              resources. We do not endorse or assume responsibility for their
              content, availability, or accuracy.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Content Liability</h2>
            <p>
              We are not liable for any content you or other users upload or
              link to via ReImagine
              <span className="legal-page__brand-italic">2.0</span>. You agree
              not to upload or disseminate unlawful, defamatory, or offensive
              content.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Limitation of Liability</h2>
            <p>
              The ReImagine
              <span className="legal-page__brand-italic">2.0</span> platform
              provides data maturity assessment insights based on inputs
              provided by the user. While we strive for accuracy, Traxccel LLC is
              not liable for any actions taken based on insights or reports
              generated through this tool.
            </p>
            <p>
              We are not liable for damages arising from the use or inability to
              use the platform, including but not limited to data loss, service
              interruption, or system errors.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Changes to Terms</h2>
            <p>
              We reserve the right to revise these terms at any time. Continued
              use of the ReImagine
              <span className="legal-page__brand-italic">2.0</span> platform after
              changes have been posted constitutes acceptance of the updated
              terms.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Contact Us</h2>
            <p>
              For inquiries related to these terms, please reach out at{" "}
              <a
                href="mailto:reimagine@traxccel.com"
                className="legal-page__email"
              >
                reimagine@traxccel.com
              </a>
              .
            </p>
          </section>
        </article>
      </div>

      <p className="legal-page__copyright">
        &copy; 2025 Traxccel. All rights reserved.
      </p>
    </div>
  );
}

export default TermsAndConditions;
